/** This is a placeholder, not real render in dom */
var TreeNode = function TreeNode() {
  return null;
};

export default TreeNode;


//////////////////
// WEBPACK FOOTER
// ./node_modules/rc-tree-select/es/TreeNode.js
// module id = 190
// module chunks = 0